import React from 'react';
import PropTypes from 'prop-types';

const Emoji = ({ label, symbol, size }) => (
  <span
    style={{ fontSize: size }}
    className="emoji"
    role="img"
    aria-label={label}
    aria-hidden={label ? 'false' : 'true'}
  >
    {symbol}
  </span>
);

Emoji.propTypes = {
  label: PropTypes.string,
  symbol: PropTypes.string.isRequired,
  size: PropTypes.string,
};

Emoji.defaultProps = {
  label: '',
  size: '16px',
};

export default Emoji;
